import { render } from "./HeadingRichText.vue?vue&type=template&id=7339df20&scoped=true"
import script from "./HeadingRichText.vue?vue&type=script&lang=js"
export * from "./HeadingRichText.vue?vue&type=script&lang=js"

import "./HeadingRichText.vue?vue&type=style&index=0&id=7339df20&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7339df20"]])

export default __exports__